import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-background-50 whitespace-nowrap">
              <span className="text-primary-400">4399</span>漫画网
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              4399漫画网提供无删减韩国漫画下拉式阅读，免费韩漫大全资源齐全多样，阅读体验流畅，让您畅享韩漫精彩。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-background-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/romance" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">恋爱韩漫</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">奇幻韩漫</Link></li>
              <li><Link to="/category/action" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">动作韩漫</Link></li>
              <li><Link to="/category/horror" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">悬疑韩漫</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>contact@4399mh.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line mt-0.5 text-primary-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>广东省广州市天河区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 4399漫画网 - 免费韩漫大全，无删减下拉式阅读体验
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}